import { Link } from 'react-router-dom';

export default function CtaBannerSection() {
  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=lush%20tropical%20green%20forest%20leaves%20background%20with%20soft%20sunlight%20bokeh%20effect%2C%20vibrant%20emerald%20green%20nature%20scene%2C%20botanical%20garden%20aesthetic%2C%20health%20wellness%20brand%20background%2C%20rich%20green%20tones&width=1920&height=600&seq=cta-banner-bg-01&orientation=landscape"
          alt="CTA 背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#2d5a2d]/80" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          {/* Left */}
          <div className="text-center lg:text-left w-full lg:w-auto">
            <h2 className="text-white font-bold leading-tight mb-4">
              準備好開始您的<br />品牌代工之旅了嗎？
            </h2>
            <p className="text-green-200 text-[1.0625rem] leading-[1.75] max-w-xl">
              立即聯絡康永生技專業業務團隊，讓我們為您打造專屬的代工解決方案，快速實現您的品牌夢想。
            </p>
          </div>

          {/* Right - CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0 w-full lg:w-auto">
            <Link
              to="/contact/form"
              className="whitespace-nowrap bg-white text-[#2d5a2d] hover:bg-green-50 font-bold text-[1.0625rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer text-center"
            >
              立即諮詢
            </Link>
            <Link
              to="/services"
              className="whitespace-nowrap bg-transparent border-2 border-white text-white hover:bg-white/10 font-semibold text-[1.0625rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer text-center"
            >
              瀏覽服務項目
            </Link>
          </div>
        </div>

        {/* Trust badges */}
        <div className="mt-12 pt-10 border-t border-white/20 grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6">
          {[
            { icon: 'ri-shield-check-line', text: 'HACCP認證廠房' },
            { icon: 'ri-award-line', text: 'ISO 品質認證' },
            { icon: 'ri-global-line', text: '專業代工服務' },
            { icon: 'ri-customer-service-2-line', text: '專屬服務支援' },
          ].map((badge) => (
            <div key={badge.text} className="flex items-center justify-center gap-2 sm:gap-3">
              <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0">
                <i className={`${badge.icon} text-green-300 text-lg sm:text-xl`} />
              </div>
              <span className="text-white font-medium text-[0.875rem] sm:text-[0.9375rem] whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
